import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GET_ALL_REVIEWS, CREATE_REVIEW } from "../../helpers/url_helper";

import { APIClient } from "../../helpers/api_helper";
const api = new APIClient();

const getReviews = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const res = await api.get(
      `${process.env.REACT_APP_COMMON_URL}${GET_ALL_REVIEWS}?${queryParams}`
    );

    if (res.status) {
    } else {
      toast.error(res.message, { theme: "colored" });
      // toast.error(res, { theme: "colored" });
    }
    return res;
  } catch (error) {
    toast.error(error, { theme: "colored" });
  }
};

const createReview = async (obj) => {
  try {
    const res = await api.create(
      `${process.env.REACT_APP_COMMON_URL}${CREATE_REVIEW}`,
      obj
    );

    if (res?.status) {
      toast.success(res?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {

      toast.error(res?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    return res;
  } catch (error) {
    toast.error(error, {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
};

export const services = {
  getReviews,
  createReview,
};
